import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import dict from '@/mixins/component-dict';
export default {
  name: 'd2-dict-radio',
  mixins: [dict],
  props: {
    button: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var tagName = this.button ? 'el-radio-button' : 'el-radio';
    var component = h("el-radio-group", {
      "attrs": _objectSpread({}, this.attrs),
      "on": {
        "change": this.onChange
      },
      "model": {
        value: _this.currentValue,
        callback: function callback($$v) {
          _this.currentValue = $$v;
        }
      }
    }, [this.options.map(function (item) {
      return h(tagName, {
        "attrs": {
          "label": item.value
        }
      }, [item.label]);
    })]);
    return component;
  }
};